import { useAuthStore } from '@/stores/auth'

const rootUrl = import.meta.env.VITE_WEB_PORTAL_ROOT + '/#/'

/** Generate a full URL to given resource on the web portal */
export function makeWebPortalUrl(url: string) {
	const auth = useAuthStore()
	const args = auth.viewingAsAnother
		? `?viewingAsUser=${auth.user?.salesContact?.id}`
		: ''
	return rootUrl + url + args
}
